<template>
  <div class="personal_center chinese_container">
    <div class="personal_center_header">
      <img
        src="https://download.hecoos.com/enlightv/2025-17/9afd9fdb8b5717b4b118b43b3c449e13.png"
        alt=""
        @click="goIndex('/')"
      />
      <div class="header_right">
        <button @click="goOrder" class="btn1">我的订单</button>
        <button @click="logOut" class="btn2">登出</button>
        <button @click="goIndex('/')" class="btn3">返回首页</button>
      </div>
    </div>
    <div style="padding-bottom: 60px">
      <div class="personal_content">
        <div class="personal_content_left">
          <h3>个人信息</h3>
          <div class="info-grid">
            <div class="info-column">
              <div class="info-row">
                <label>hccoos账号</label>
                <input
                  type="text"
                  :value="userInfo.hecoos_account || '暂无'"
                  disabled
                />
              </div>
              <div class="info-row">
                <label>姓名</label>
                <input type="text" :value="userInfo.name || '暂无'" disabled />
              </div>
              <div class="info-row">
                <label>手机号码</label>
                <input type="text" :value="userInfo.phone || '暂无'" disabled />
              </div>
              <div class="info-row">
                <label>公司名称</label>
                <input
                  type="text"
                  :value="userInfo.company || '暂无'"
                  disabled
                />
              </div>
              <div class="info-row">
                <label>职位</label>
                <input
                  type="text"
                  :value="userInfo.position || '暂无'"
                  disabled
                />
              </div>
            </div>
            <div class="info-column">
              <div class="info-row">
                <label>昵称</label>
                <input type="text" :value="userInfo.rname || '暂无'" disabled />
              </div>
              <div class="info-row">
                <label>邮箱</label>
                <input type="text" :value="userInfo.email || '暂无'" disabled />
              </div>
              <div class="info-row">
                <label>所在城市</label>
                <input type="text" :value="userInfo.city || '暂无'" disabled />
              </div>
              <div class="info-row">
                <label>从业时间</label>
                <input
                  type="text"
                  :value="userInfo.work_duration || '暂无'"
                  disabled
                />
                <!-- <input type="text" :value="userInfo.work_duration + '年' || ''" disabled /> -->
              </div>
              <div class="info-row">
                <button v-if="userInfo.phone || userInfo.email" class="forgetPsd"  @click="pageTransition('/forget_password')" >
                  修改密码
                </button>
              </div>
            </div>
          </div>
          <div class="member-info">
            <span
              >会员时间：
              <span
                v-text="start_time ? start_time + '~' + stop_time : '无'"
              ></span
            ></span>
            <button
              class="renew-btn"
              @click="pageTransition('/SoftwareSubscriptions')"
            >
              续费
            </button>
          </div>
        </div>
        <div class="divider"></div>
        <div class="personal_content_right">
          <h3>会员订阅</h3>
          <div class="subscription-options">
            <div
              class="subscription-item"
              @click="pageTransition('/SoftwareSubscriptions?orderType=3')"
            >
              <p class="price">98.00元/周</p>
            </div>
            <div
              class="subscription-item"
              @click="pageTransition('/SoftwareSubscriptions?orderType=1')"
            >
              <p class="price">198.00元/月</p>
              <p class="daily-price">6.5元/天</p>
            </div>
            <div
              class="subscription-item"
              @click="pageTransition('/SoftwareSubscriptions?orderType=2')"
            >
              <p class="price">1998.00元/年</p>
              <p class="daily-price">5.4元/天</p>
            </div>
          </div>
        </div>
      </div>
      <button
        v-if="!userInfo.is_trial && (userInfo.phone || userInfo.email)"
        class="free-authorization-btn"
        @click="showModal = true"
      >
        获取一个月免费授权
      </button>
      <div v-else class="footer_text">
        <p>
          邀请链接： <span v-text="inviteLink + userInfo.recode"></span
          ><button @click="copyInviteLink">复制链接</button>
        </p>
        <p>
          请分享此链接，
          成功邀请一名好友注册hcoos会员后，您的会员账号将自动获得7天免费时长；邀请多名好友注册，可累计免费时长，最高60天（价值396元）
        </p>
        <table v-if="userInfo.invite_register.length > 0">
          <thead>
            <tr>
              <th>编号</th>
              <th>邀请人</th>
              <th>注册时间</th>
              <th>奖励时长</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(userInfoItem, index) in userInfo.invite_register"
              :key="userInfoItem.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ userInfoItem.name }}</td>
              <td>{{ userInfoItem.register_time }}</td>
              <td>{{ userInfoItem.time }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Dialog -->
      <div
        v-if="showModal"
        class="modal-overlay"
        @click.self="showModal = false"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3>完善个人信息</h3>
            <button class="close-btn" @click="showModal = false">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p data-label="昵称：">
              <input type="text" v-model="userInfo.rname" />
            </p>
            <p data-label="姓名：">
              <input type="text" v-model="userInfo.name" />
            </p>
            <p data-label="邮箱：">
              <input type="text" v-model="userInfo.email" />
            </p>
            <p data-label="公司名称：">
              <input type="text" v-model="userInfo.company" />
            </p>
            <p data-label="所在城市：">
              <input type="text" v-model="userInfo.city" />
            </p>
            <p data-label="职位：">
              <input type="text" v-model="userInfo.position" />
            </p>
            <p data-label="从业时间：">
              <select v-model="userInfo.work_duration" name="" id="">
                <option value="1">1年</option>
                <option value="2">2年</option>
                <option value="3">3年</option>
                <option value="4">4年</option>
                <option value="5">5年</option>
                <option value="6">6年</option>
                <option value="7">7年</option>
                <option value="8">8年</option>
                <option value="9">9年</option>
                <option value="10">10年</option>
                <option value="11">10年以上</option>
              </select>
            </p>
          </div>
          <div class="modal-footer">
            <button class="confirm-btn" @click="confirmAuthorization">
              确认授权
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { Message } from "element-ui";
import { getFreeVip, getPaySuccess } from "@/api/api";
export default {
  data() {
    return {
      userInfo: {
        account: "",
        nickname: "",
        name: "",
        email: "",
        phone: "",
        city: "",
        company: "",
        workTime: "",
        position: "",
        memberExpire: "",
        recode: "",
        is_trial: "",
      },
      showModal: false,
      inviteLink: "",
      start_time: "",
      stop_time: "",
      // selectedOption: null
    };
  },
  created() {
    // 动态生成邀请链接
    this.inviteLink = `${window.location.origin}/#/register?recode=`;
    // console.log(window.location.origin);

    // console.log(this.inviteLink);

    if (store.state.adminUserInfo && store.state.adminUserInfo.id) {
      this.getPaySuccess();
    }
  },
  beforeMount() {
    this.userInfo = store.state.adminUserInfo;
    this.userInfo.is_trial = Number(this.userInfo.is_trial);
  },
  methods: {
    getPaySuccess() {
      getPaySuccess().then((res) => {
        if (res.code == 200) {
          if (res.data) {
            let { start_time, stop_time } = res.data;
            this.start_time = start_time;
            this.stop_time = stop_time;
          }
        }
      });
    },
    shuC(msg) {
      console.log(msg);
    },
    goOrder() {
      this.$router.push("/order");
    },
    goIndex(path) {
      this.$router.push(path);
    },
    logOut() {
      store.commit("clearAdminUserInfo");
      localStorage.clear();
      this.$router.push("/login");
    },
    pageTransition(url) {
      this.$router.push({
        path: url,
      });
    },
    confirmAuthorization() {
      // console.log(this.userInfo);
      let postData = {
        name: this.userInfo.name,
        rname: this.userInfo.rname,
        email: this.userInfo.email,
        company: this.userInfo.company,
        city: this.userInfo.city,
        position: this.userInfo.position,
        work_duration: this.userInfo.work_duration,
      };
      // console.log(postData);

      getFreeVip(postData).then((res) => {
        Message.success("获取成功，请重新登录。");
        setTimeout(() => {
          this.logOut();
        }, 1000);
      });

      this.showModal = false;
    },
    copyInviteLink() {
      navigator.clipboard
        .writeText(this.inviteLink + this.userInfo.recode)
        .then(() => {
          Message.success("链接已复制到剪贴板");
        })
        .catch((err) => {
          Message.error("复制失败，请手动复制...");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/optimize_adaptation.scss";
.personal_center {
  font-family: Arial, sans-serif;
  color: #333;
  position: relative;

  .personal_center_header {
    width: 100%;
    min-width: 1000px;
    height: 152px;
    background-color: #24272a;
    padding: 50px 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 204px;
      height: 37px;
      cursor: pointer;
    }

    .header_right {
      display: flex;
      gap: 20px;

      button {
        font-size: 24px;
        height: 54px;
        border-radius: 27px;
        padding: 0 36px;
        cursor: pointer;
        border: none;
        // font-weight: bold;
      }
      .btn1 {
        background-color: #1684ed;
        color: #fff;
      }
      .btn2 {
        background-color: #070809;
        color: #fff;

        &:hover {
          background-color: #2a82e4;
        }
      }

      .btn3 {
        background-color: #fff;
        color: #000;

        &:hover {
          background-color: #e4e6ef;
        }
      }
    }
  }

  .personal_content {
    width: 70%;
    margin: 20px auto;
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    gap: 40px;

    .personal_content_left {
      flex: 1;
      padding: 0 20px;

      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 30px;
        padding-bottom: 10px;
        text-align: center;
      }

      .info-grid {
        display: flex;
        gap: 40px;
      }

      .info-column {
        flex: 1;
      }

      .info-row {
        margin-bottom: 20px;

        .forgetPsd {
          border: 1px solid #2a82e4;
          background-color: #fff;
          color: #2a82e4;
          width: 100%;
          height: 40px;
          border-radius: 20px;
          margin-top: 23px;
          cursor: pointer;

          &:hover {
            border: 1px solid #fff;
            background-color: #2a82e4;
            color: #fff;
          }
        }

        label {
          display: block;
          font-size: 14px;
          color: #777;
          margin-bottom: 5px;
        }

        input {
          width: 100%;
          height: 40px;
          border: 1px solid #e4e6ef;
          border-radius: 4px;
          padding: 0 10px;
          background-color: #f9f9f9;
          font-size: 14px;
        }
      }

      .member-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        padding-top: 15px;
        border-top: 1px solid #eee;

        span {
          font-size: 14px;
          color: #333;
        }

        .renew-btn {
          border: none;
          background-color: #2a82e4;
          color: #fff;
          width: 26%;
          height: 40px;
          border-radius: 20px;
          margin-top: 10px;
          cursor: pointer;
          transform: translateY(-4px);

          &:hover {
            border: 1px solid #2a82e4;
            background-color: #fff;
            color: #2a82e4;
          }
        }
      }
    }

    .divider {
      width: 2px;
      background-color: #eee;
    }

    .personal_content_right {
      flex: 1;
      padding: 0 20px;

      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 54px;
        padding-bottom: 10px;
        text-align: center;
      }

      .subscription-options {
        display: flex;
        flex-direction: column;
        gap: 32px;
      }

      .subscription-item {
        border: 1px solid #e4e6ef;
        border-radius: 70px;
        padding: 30px 20px;
        cursor: pointer;
        transition: all 0.3s;
        text-align: center;

        &:hover {
          border-color: #2a82e4;
          background-color: #f5f9ff;
        }

        .price {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        .daily-price {
          font-size: 14px;
          color: #2a82e4;
        }
      }
    }
  }

  .free-authorization-btn {
    display: block;
    width: 300px;
    height: 50px;
    margin: 30px auto;
    background-color: #24272a;
    color: #fff;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s;

    &:hover {
      background-color: #2a82e4;
    }
  }

  .footer_text {
    text-align: center;
    font-size: 16px;

    span {
      color: #2a82e4;
    }

    button {
      border: none;
      font-size: 10px;
      padding: 6px 12px;
      border-radius: 13px;
      margin-left: 6px;
      background-color: #cccccc;
      color: #fff;
      cursor: pointer;
    }

    table {
      width: 70%;
      border-collapse: collapse;
      margin-top: 20px;
      margin: 20px auto;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tr:hover {
      background-color: #f1f1f1;
    }

    .header {
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #777;
      padding: 0;
      line-height: 1;
    }
  }

  .modal-body {
    padding: 20px 54px;

    p {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      &::before {
        content: attr(data-label);
        display: inline-block;
        width: 80px;
        text-align: justify;
        text-align-last: justify;
        padding-right: 10px;
      }

      input,
      select {
        // 同时为input和select设置相同样式
        flex: 1;
        height: 40px;
        border: 1px solid #e4e6ef;
        border-radius: 4px;
        padding: 0 10px;
        background-color: #f9f9f9;
        font-size: 14px;
        appearance: none; // 移除默认样式
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 12px;
      }

      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");

        option {
          padding: 8px;
        }
      }
    }
  }

  .modal-footer {
    padding: 20px;
    border-top: 1px solid #eee;
    text-align: center;

    .confirm-btn {
      background-color: #2a82e4;
      color: white;
      border: none;
      border-radius: 20px;
      padding: 10px 30px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #1a6bc8;
      }
    }
  }
}
</style>
